// extracted by mini-css-extract-plugin
export default {"removeColumn":"Roles__removeColumn-aNAJI"};